import { createSelector } from 'reselect';
import { State, ServiceLocationsState, ServiceLocationInfo } from 'types';

export const getServiceLocation = (
  state: State,
  serviceLocationId: number | null,
): ServiceLocationInfo | undefined => state.entities.serviceLocations?.[serviceLocationId];

export const _getServiceLocations = (state: State): ServiceLocationsState | undefined =>
  state.entities.serviceLocations;

export const getServiceLocations = createSelector(_getServiceLocations, (serviceLocationsById) => {
  if (!serviceLocationsById) return undefined;

  return Object.values(serviceLocationsById);
});
